import React from 'react';
import {useHistory} from 'react-router-dom';
import wrap from 'wraptile';

import {handleFailure} from './LoginContainer';
import Logout from './Logout';

export const getOnSuccess = wrap((logOut: any, {history}:any) => {
    logOut();
    localStorage.removeItem('jwt');
    
    history.push('/login');
});

export const getLocalStorageValue = (item: any) => {
    return Boolean(localStorage.getItem(item));
};

export default function LogoutContainer({logOut, setNotification}:any) {
    const history = useHistory();
    const onSuccess = getOnSuccess(logOut, {
        history,
    });
    const onFailure = handleFailure(setNotification);
    const isLoggedIn = getLocalStorageValue('jwt');
    
    return (
        <Logout
            onLogoutSuccess={onSuccess}
            onFailure={onFailure}
            isLoggedIn={isLoggedIn}
        />
    );
}
